import React from 'react'
import { Card, Row, Col, Select, Table } from 'antd'
import { auditTrailsTableDes } from '../../../Utils/constants'
import moment from 'moment'

const AuditTrailTableDes = ({ data, test }) => {

    console.log({ data })

    return (
        <>
            {data?.detailsBefore ? <AuditTrailDetails head={'Details Before'} data={data?.detailsBefore || {}} /> : <></>}
            {data?.detailsAfter ? <AuditTrailDetails head={'Details After'} data={data?.detailsAfter || {}} /> : <></>}
        </>
    )
}

export default AuditTrailTableDes

const AuditTrailDetails = ({ data, head }) => {

    const keyChecker = (key) => {
        if (key === 'product') return 'Product Name'
        if (key === 'stopTime') return 'Downtime'
        return (key)?.toUpperCase()
    }

    let objsToMap = ['email', 'emailCC', 'emailBCC']
    const valueChecker = (obj, key) => {
        if (key === 'product') return obj[key]?.name
        if (key === 'stopTime') return obj[key]?.downtime
        if (obj[key] == null) return 'N/A'
        if (key === 'lines') return obj[key]?.map(({ lineName }) => ` ${lineName}`)
        if (objsToMap.includes(key)) return obj[key]?.map((data) => ` ${data}`)
        return obj[key]
    }

    return (
        <div span={24} className={`auditTrails_log_description_container${data?.weeklyTargets ? '_weekly' : ''}`}>
            {!data?.weeklyTargets &&
                <h2 style={{ margin: '15px' }}> {head}</h2>
            }
            {
                data?.weeklyTargets ?
                    <WeeklyTargets targets={data?.weeklyTargets} />
                    :
                    Object.keys(data || {})?.map((key, i) => (
                        <Row key={i} className='auditTrails_log_description_box diver'>
                            <Col className='auditTrails_log_description_col' span={12}>
                                {keyChecker(key)}
                            </Col>
                            <Col className='auditTrails_log_description_col' span={12}>
                                {valueChecker(data, key)}
                            </Col>
                        </Row>
                    ))
            }
        </div>
    )
}


const WeeklyTargets = ({ targets = {} }) => {

    return (
        <>
            {
                Object.keys(targets || {})?.map((key, i) => (
                    <Details head={key} targetsForDate={targets[key] || []} />
                ))
            }
        </>
    )
}


const Details = ({ targetsForDate = [], head }) => {

    let keysToShow = [
        { name: 'Value', key: 'value' },
        { name: 'Day', key: 'day' },
        { name: 'Updated At', key: 'updated_at' },
    ]
    let finalArray = [...targetsForDate?.slice(0, (targetsForDate?.length - 1)), { value: '', day: '', updated_at: '', total: targetsForDate[targetsForDate?.length - 1]?.totalTargetValue }]
    return (
        <>
            <h2 style={{ margin: '15px' }}>Weekly Targets -> {head}</h2>

            <Row className='auditTrails_log_description_head_weekly auditTrails_log_description_box diver'>
                {keysToShow?.map(({ name }) => (
                    <Col className='auditTrails_log_description_col_weekly' span={6}>
                        {name}
                    </Col>
                ))}
                <Col className='auditTrails_log_description_col_weekly auditTrails_log_description_col_weekly_last' span={6}>
                    Total Target Value
                </Col>
            </Row>
            {
                finalArray?.map((target, i) => (
                    <Row key={i} className='auditTrails_log_description_box diver'>
                        {keysToShow?.map(({ key }) => (
                            <Col className={`auditTrails_log_description_col ${(target[key] && key == 'value') && 'bgGreen'} ${(!target[key] && key == 'value') && 'auditTrails_log_description_row_weekly_left'}`} span={6}>
                                {target[key]}
                            </Col>
                        ))}
                        <Col className={`auditTrails_log_description_col ${target?.total && 'auditTrails_log_description_row_weekly_right'}`} span={6}>
                            {target?.total}
                        </Col>
                    </Row >
                ))
            }
        </>
    )
}